//Separated from DrawingUtil so it can be used by CanvasMath

const Math2D = require("./Math2D");
const CanvasUtil = require("./CanvasUtil");
const ColorUtil = require("./ColorUtil");

const defaultColors = ColorUtil.getCurrentScheme();

// Draws the background of a circle button
const drawCircleButtonBackground = function(ctx, rect, props = {}) {
	const colors = props.colors || defaultColors;
	ctx.save();
	ctx.lineWidth = CanvasUtil.getOptimalLineWidth(ctx);
	ctx
		.bp()
		.arc(
			rect[0] + rect[2] / 2,
			rect[1] + rect[3] / 2,
			rect[2] / 2,
			0,
			2 * Math.PI
		)
		.fill(props.fillColor || colors.transparent)
		.stroke(props.strokeColor || colors.inputText);
	ctx.restore();
};

// Draws an icon of a certain type of input
// type: "simple", "fraction", "mixed", "overbar", "sqrt"
const drawInputBoxes = function(ctx, rect, type, color) {
	color = color || defaultColors.inputText;
	const lineWidth = CanvasUtil.getOptimalLineWidth(ctx);
	let size = rect.h / 3;
	let drawFraction = false;
	let drawWhole = false;
	let wholeX = rect.x + (rect.w - size) / 2;
	let wholeY = rect.y + (rect.h - size) / 2;
	let fracX;
	ctx.save();
	ctx.lineWidth = (type === "sqrt" ? 1 : 1.5) * lineWidth;
	if (type === "simple") {
		drawWhole = true;
	} else if (type === "overbar") {
		drawWhole = true;
		wholeY += 2 * lineWidth;
		//Draw the extra overbar line
		ctx
			.bp()
			.M(wholeX - lineWidth, wholeY - 3 * lineWidth)
			.L(wholeX + size + lineWidth, wholeY - 3 * lineWidth)
			.stroke(color);
	} else if (type === "fraction") {
		drawFraction = true;
		size = rect.h / 4;
		fracX = rect.x + (rect.w - size) / 2;
	} else if (type === "mixed") {
		drawFraction = true;
		drawWhole = true;
		const mixedGap = 3 * lineWidth;
		size = rect.h / 4;
		wholeX = rect.x + (rect.w - 2 * size - mixedGap * 2) / 2;
		wholeY = rect.y + (rect.h - size) / 2;
		fracX = wholeX + size + mixedGap;
	} else if (type === "sqrt") {
		drawWhole = true;
		size = rect.h / 3.5;
		const rootWidth = lineWidth * 6;
		const leftX = rect.x + (rect.w - size - rootWidth - 3 * lineWidth) / 2;
		const topY = rect.y + (rect.h - 2 * lineWidth - size) / 2;
		wholeX = leftX + rootWidth;
		wholeY = topY + 2 * lineWidth;
		const rootY = wholeY + size / 2;
		ctx
			.bp()
			.M(leftX, rootY + rootWidth * (1 / 8))
			.L(leftX + rootWidth * (1 / 8), rootY)
			.L(leftX + rootWidth * (1 / 2), wholeY + size)
			.L(wholeX - lineWidth, topY)
			.L(wholeX + size + lineWidth, topY)
			.stroke(color);
	}

	//Draw whole part
	if (drawWhole) {
		ctx
			.bp()
			.rect(wholeX, wholeY, size, size)
			.fill(color);
	}

	// Draw fraction part
	if (drawFraction) {
		const fracBarSpace = 5 * lineWidth;
		const fracY = rect.y + (rect.h - 2 * size - fracBarSpace) / 2;
		const fracLineExtra = type === "fraction" ? 2 * lineWidth : lineWidth;
		ctx
			.bp()
			.rect(fracX, fracY, size, size)
			.fill(color);
		ctx
			.bp()
			.rect(fracX, fracY + size + fracBarSpace, size, size)
			.fill(color);
		ctx
			.bp()
			.M(fracX - fracLineExtra, rect.y + rect.h / 2)
			.L(fracX + size + fracLineExtra, rect.y + rect.h / 2)
			.stroke(color);
	}

	ctx.restore();
};

const drawInputCircleButton = function(ctx, rect, cS, type, isSelected) {
	cS = cS || defaultColors;
	const rectArray = Math2D.rectToArray(rect);
	drawCircleButtonBackground(ctx, rectArray, {
		fillColor: isSelected ? cS.inputText : cS.defaultFill,
		strokeColor: isSelected ? cS.inputText : cS.lightGrayFill,
	});
	const drawColor = isSelected ? cS.defaultFill : cS.lightGrayFill;
	drawInputBoxes(ctx, rect, type, drawColor);
};

module.exports = {
	drawInputCircleButton,
};
